module.exports = __webpack_public_path__ + "static/img/3.a0e18d8f.jpg";